<template>
    <div>
        <vx-card>
            <vs-tabs class="tab-action-btn-fill-conatiner">
                <vs-tab :label="$t('menuCustomer.customerInfo')" icon-pack="feather" icon="icon-user">
                    <div class="vx-row">
                        <div class="vx-col md:w-1/3 w-full mt-2">
                            <label class="vs-input--label">{{ $t('menuCustomer.customerCode') }}</label>
                            <span class="text-danger">*</span>
                            <vs-input class="w-full" :disabled="isUpdate"
                                      v-model="customerInfo.customerCode"
                                      v-validate="'required'" name="employeeCode"/>
                            <span class="text-danger text-sm">{{ errors.first('employeeCode') }}</span>
                        </div>

                        <div class="vx-col md:w-1/3 w-full mt-2">
                            <label class="vs-input--label">{{ $t('menuCustomer.customerName') }}</label>
                            <span class="text-danger">*</span>
                            <vs-input class="w-full" v-model="customerInfo.fullName"
                                      v-validate="'required'" name="lastName"/>
                            <span class="text-danger text-sm">{{ errors.first('lastName') }}</span>
                        </div>

                        <div class="vx-col md:w-1/3 w-full mt-2">
                            <label class="vs-input--label">{{ $t('menuCustomer.identityCard') }}</label>
                            <span class="text-danger">*</span>
                            <vs-input class="w-full" v-model="customerInfo.identityCard"
                                      v-validate="'required'" name="CMT"/>
                            <span class="text-danger text-sm">{{ errors.first('CMT') }}</span>
                        </div>

                    </div>
                    <div class="vx-row">
                        <div class="vx-col md:w-1/3 w-full mt-2">
                            <label class="vs-input--label">{{ $t('menuCustomer.phoneNumber') }}</label>
                            <span class="text-danger">*</span>
                            <vs-input class="w-full" v-model="customerInfo.phone"
                                      v-validate="'required|numeric|min:10|max:11'" name="phoneNumber"/>
                            <span class="text-danger text-sm">{{ errors.first('phoneNumber') }}</span>
                        </div>
                        <div class="vx-col md:w-1/3 w-full mt-2">
                            <label class="vs-input--label">{{ $t('menuCustomer.city') }}</label>
                            <span class="text-danger">*</span>
                            <v-select class="" v-model="province" :clearable="false" :options="cityOptions"
                                      data-vv-validate-on="blur" v-validate="'required'" name="organizationType">
                                <span slot="no-options"> {{ $t('menuOrganization.noOption') }} </span>
                            </v-select>
                            <span class="text-danger text-sm">{{ errors.first('city') }}</span>
                        </div>
                        <div class="vx-col md:w-1/3 w-full mt-2">
                            <label class="vs-input--label">{{ $t('menuCustomer.district') }}</label>
                            <span class="text-danger">*</span>
                            <v-select class="" v-model="district" :clearable="false" :options="districtOptions"
                                      data-vv-validate-on="blur" v-validate="'required'" name="organizationType">
                                <span slot="no-options"> {{ $t('menuOrganization.noOption') }} </span>
                            </v-select>
                            <span class="text-danger text-sm">{{ errors.first('district') }}</span>
                        </div>

                    </div>
                    <div class="vx-row">
                        <div class="vx-col md:w-1/3 w-full mt-2">
                            <label class="vs-input--label">{{ $t('menuCustomer.commune') }}</label>
                            <span class="text-danger">*</span>
                            <v-select class="" v-model="subDistrict" :clearable="false"
                                      :options="subDistrictOptions"
                                      data-vv-validate-on="blur" v-validate="'required'" name="organizationType">
                                <span slot="no-options"> {{ $t('menuOrganization.noOption') }} </span>
                            </v-select>
                            <span class="text-danger text-sm">{{ errors.first('subDistrict') }}</span>
                        </div>
                        <div class="vx-col md:w-1/3 w-full mt-2">
                            <label class="vs-input--label">{{ $t('menuCustomer.houseNumber') }}</label>
                            <span class="text-danger">*</span>
                            <vs-input class="w-full" v-model="customerInfo.houseNumber"
                                      v-validate="'required|max:50'" name="houseNumber"/>
                            <span class="text-danger text-sm">{{ errors.first('houseNumber') }}</span>
                        </div>
                        <div class="vx-col md:w-1/3 w-full mt-2">
                            <vs-input class="w-full" :label=" $t('menuCustomer.address') " v-model="fullAddressModel"
                                      v-validate="''" name="full_address" readonly="true"/>
                        </div>
                    </div>

                    <div class="vx-row">
                        <div class="vx-col md:w-1/3 w-full mt-4">
                            <label class="vs-input--label">{{ $t('menuCustomer.faceData') }}</label>
                            <div class="vx-row">
                                <div class="vx-col">
                                    <vue-upload-multiple-image
                                        @upload-success="uploadImageSuccess"
                                        @before-remove="beforeRemove"
                                        @edit-image="editImage"
                                        @data-change="dataChange"
                                        :data-images="images"
                                    ></vue-upload-multiple-image>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Save & Reset Button -->
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <div class="mt-8 flex flex-wrap items-center justify-end">
                                <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm">{{
                                        `${isUpdate ?
                                            $t('button.update') : $t('button.create')}`
                                    }}
                                </vs-button>
                                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.back()">
                                    {{ $t('button.back') }}
                                </vs-button>
                            </div>
                        </div>
                    </div>
                </vs-tab>
            </vs-tabs>
        </vx-card>
    </div>
</template>

<script>

import VueUploadMultipleImage from '../../../components/VueUploadMultipleImage'
import province from '@/assets/utils/province.js';
import vSelect from 'vue-select'

export default {
    components: {
        VueUploadMultipleImage,
        vSelect
    },
    data() {
        return {
            cityOptions: province.getProvince(),
            districtOptions: [],
            subDistrictOptions: [],
            isUpdate: false,
            customerInfo: {
                id: null,
                customerCode: null,
                fullName: null,
                phone: null,
                organizationId: null,
                city: null,
                district: null,
                fullAddress: null,
                houseNumber: null
            },
            images: [],
            user_data: null,
            imagesId: []
        }
    },
    async created() {
        let userInfo = localStorage.getItem("userInfo");
        this.customerInfo.organizationId = JSON.parse(userInfo).organization.id;

        this.customerInfo.id = this.$route.query.id;
        if (this.customerInfo.id) {
            this.isUpdate = true;
            await this.findById();
            for (const x of this.customerInfo.fileManagers) {
                let data = await this.toDataURL(x.url);
                let dataImage = data.xhr.response;
                let metadata = {
                    type: 'image/jpeg'
                };
                let file = new File([dataImage], x.fileName, metadata);
                this.images.push({
                    name: x.fileName,
                    path: data.imgBase64,
                    highlight: 1,
                    default: 1,
                    file: file
                });
            }
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any()
        },
        province: {
            get() {
                return {
                    label: this.getLabelString(this.cityOptions.find(x => x.value === this.customerInfo.city)),
                    value: this.customerInfo.city
                }
            },
            set(obj) {
                if (obj.value) {
                    this.customerInfo.city = obj.value;
                    this.districtOptions = province.getDistrict(obj.value);
                    this.customerInfo.district = this.districtOptions[0].value;
                    this.subDistrictOptions = province.getSubDistrict(this.customerInfo.city, this.customerInfo.district);
                    this.customerInfo.street = this.subDistrictOptions[0].value;
                } else {
                    this.customerInfo.city = null;
                    this.districtOptions = [{value: null, label: this.$t('menuCustomer.all')}];
                    this.customerInfo.district = null;
                    this.subDistrictOptions = [{value: null, label: this.$t('menuCustomer.all')}];
                    this.customerInfo.street = null;
                }
            }
        },
        district: {
            get() {
                return {
                    label: this.getLabelString(this.districtOptions.find(x => x.value === this.customerInfo.district)),
                    value: this.customerInfo.district
                }
            },
            set(obj) {
                this.customerInfo.district = obj.value;
                this.subDistrictOptions = province.getSubDistrict(this.customerInfo.city, obj.value);
                this.customerInfo.street = this.subDistrictOptions[0].value;
            }
        },
        subDistrict: {
            get() {
                return {
                    label: this.getLabelString(this.subDistrictOptions.find(x => x.value === this.customerInfo.street)),
                    value: this.customerInfo.street
                }
            },
            set(obj) {
                this.customerInfo.street = obj.value
            }
        },
        fullAddressModel: {
            get() {
                if (this.province.value) {
                    let fullAddress = `${this.customerInfo.houseNumber ? this.customerInfo.houseNumber + ', ' : ''}${this.subDistrict.label ? this.subDistrict.label + ', ' : ''}${this.district.label}, ${this.province.label}`;
                    this.customerInfo.fullAddress = fullAddress;
                    return fullAddress;
                } else {
                    return null;
                }
            },
        }
    },
    methods: {
        toDataURL(url) {
            return new Promise(resolve => {
                let xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    let reader = new FileReader();
                    reader.onloadend = function () {
                        resolve({imgBase64: reader.result, xhr: xhr});
                    }
                    reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url);
                xhr.responseType = 'blob';
                xhr.send();
            })
        },
        findById() {
            return new Promise((resolve, reject) => {
                this.$crm.get('customer/find-by-id/' + this.customerInfo.id).then((response) => {
                    this.customerInfo = response.data;
                    this.districtOptions = province.getDistrict(this.customerInfo.city);
                    this.subDistrictOptions = province.getSubDistrict(this.customerInfo.city, this.customerInfo.district);
                    resolve(true);
                }).catch((err) => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        title: 'Có lỗi sảy ra!',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                    reject(false);
                });
            })
        },
        uploadImageSuccess(formData, index, fileList, file) {
            this.images = fileList;
            this.setIsUpdateImages();
        },
        beforeRemove(index, done, fileList) {
            this.images = fileList;
            this.setIsUpdateImages();
            done();
        },
        editImage(formData, index, fileList) {
            this.images = fileList;
            this.setIsUpdateImages();
        },
        dataChange(data) {
            this.images = fileList;
            this.setIsUpdateImages();
        },
        setIsUpdateImages() {
            if (this.isUpdate) {
                this.isUpdateImages = true;
            }
        },
        getLabelString(object) {
            return (object && object.label) || this.$t('menuCustomer.undefined');
        },

        manufactureString(type) {
            let typeString = this.manufactureOptions.find(x => x.value === type);
            return (typeString && typeString.label) || this.$t('menuCustomer.undefined');
        },

        async saveChanges(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            if (this.images.length != 0 && !this.isUpdate || this.isUpdate && this.isUpdateImages) {
                if (this.images.length != 0) {
                    await this.handleClickUploadFile();
                } else {
                    this.imagesId = [];
                }

                this.customerInfo.images = this.imagesId;
            }
            delete this.customerInfo.fileManagers;
            let url = this.isUpdate ? `/customer/update` : `/customer/create`;
            this.$vs.loading();
            this.$crm.post(url, this.customerInfo).then((res) => {
                this.$vs.notify({
                    color: 'success',
                    text: `${this.isUpdate ? this.$t('menuCustomer.updateCustomerSS') : this.$t('menuCustomer.addCustomerSS')}`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.$router.back();
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        handleClickUploadFile() {
            return new Promise((resolve, reject) => {
                let formData = new FormData(), config = {};
                this.images.forEach((f, i) => {
                    formData.append('files', f.file);
                });
                config = {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                };
                this.$vs.loading();
                this.$crm.post('/employee/image/upload', formData, config).then((res) => {
                    this.imagesId = [];
                    this.imagesId = res.data;
                    resolve(true);
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                    reject(true);
                });
            });
        },
    },
}
</script>

<style scoped>

</style>
